import { Fragment } from 'react'
import { Link } from 'react-router'

import Page from './Page'
import { legalDocuments } from '../../legal/documents'
import { useDocumentOrigin } from '../../legal/useDocumentOrigin'

/** Renders the legal document links, opening app routes internally and URLs in a new tab. */
const LegalDocumentLinks = ({ links, onLinkClick, conjunction = 'and' }) => {
  const documentOrigin = useDocumentOrigin()

  const documents = legalDocuments(links).map(({ label, href, to }) => ({
    label,
    linkProps: to
      ? { as: Link, to, state: documentOrigin }
      : { href, target: '_blank', rel: 'noreferrer noopener' },
  }))

  return documents.map(({ label, linkProps }, index) => (
    <Fragment key={label}>
      {index > 0 && (index === documents.length - 1 ? `, ${conjunction} ` : ', ')}
      <Page.Link {...linkProps} onClick={onLinkClick}>
        {label}
      </Page.Link>
    </Fragment>
  ))
}

export default LegalDocumentLinks
